module.exports = __webpack_public_path__ + "img/aParty_042724_B.4060b506.jpg";